import { Component } from "@angular/core";

@Component({
  selector: "app-logo-forbes",
  templateUrl: "logo-forbes.component.html",
})
export class LogoForbesComponent {}
